import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bbd8b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-study-overview-frame hd-epic-frame-content" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "hd-epic__title-wrapper" }
const _hoisted_4 = { class: "hd-epic__wrapper" }
const _hoisted_5 = { class: "hd-epic__content-flex content-wrapper" }
const _hoisted_6 = { class: "hd-epic__flex-col2" }
const _hoisted_7 = { class: "hd-epic__title-wrapper" }
const _hoisted_8 = { class: "hd-epic__flex-col2" }
const _hoisted_9 = { class: "hd-epic__title-wrapper" }
const _hoisted_10 = { class: "content-wrapper" }
const _hoisted_11 = { class: "hd-epic__title-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_image_svg, {
          source: require('!html-loader!../../assets/icons/info.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-epic__content-title",
          "asset-key": "epic-study-overview-information-title"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_lyra_asset, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchFrame('epic-study-design'))),
            class: "hd-epic__content-text",
            "asset-key": `epic-study-overview-information-epic-study-design`
          }),
          _createVNode(_component_lyra_asset, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchFrame('epic-study-endpoints'))),
            class: "hd-epic__content-text",
            "asset-key": `epic-study-overview-information-epic-study-endpoints`
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_lyra_asset, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchFrame('epic-selected-inclusion-criteria'))),
            class: "hd-epic__content-text",
            "asset-key": `epic-study-overview-information-epic-sic`
          }),
          _createVNode(_component_lyra_asset, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchFrame('epic-selected-exclusion-criteria'))),
            class: "hd-epic__content-text",
            "asset-key": `epic-study-overview-information-epic-sec`
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_lyra_asset, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchFrame('epic-statistical-methods'))),
            class: "hd-epic__content-text",
            "asset-key": `epic-study-overview-information-epic-statistical-methods`
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_base_image_svg, {
            source: require('!html-loader!../../assets/icons/efficacy.svg')
          }, null, 8, ["source"]),
          _createVNode(_component_lyra_asset, {
            class: "hd-epic__content-title",
            "asset-key": "epic-study-overview-efficacy-title"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.efficacyResultsFrames, (frame, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_lyra_asset, {
              onClick: ($event: any) => (_ctx.switchFrame(frame.endpointId)),
              class: "hd-epic__content-text left-column",
              "asset-key": `epic-study-overview-efficacy-${frame.endpointId}`
            }, null, 8, ["onClick", "asset-key"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_base_image_svg, {
            source: require('!html-loader!../../assets/icons/safety.svg')
          }, null, 8, ["source"]),
          _createVNode(_component_lyra_asset, {
            class: "hd-epic__content-title",
            "asset-key": "epic-study-overview-safety-title"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safetyResultsFrames, (frame, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_lyra_asset, {
              onClick: ($event: any) => (_ctx.switchFrame(frame.endpointId)),
              class: "hd-epic__content-text right-column",
              "asset-key": `epic-study-overview-safety-${frame.endpointId}`
            }, null, 8, ["onClick", "asset-key"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_base_image_svg, {
          source: require('!html-loader!../../assets/icons/conclusion.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-epic__content-title right-column",
          "asset-key": "epic-study-overview-conclusion-title"
        })
      ]),
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__content-text--full-width",
        "asset-key": "epic-study-overview-conclusion-content"
      })
    ])
  ]))
}